export default {
	computed: {
		possuiONecessarioParaFazerOtimizacaoDeCronograma() {
			return (
				this.possuiConfiguracaoDeRegrasDeOtimizacaoPorDatas > 0 &&
				this.possuiInformacoesDeRendimentoOperacional
			)
		},
		possuiInformacoesDeRendimentoOperacional() {
			return this.regrasDeOtimizacao.rendimentoOperacional.length > 0
		},
	},
	data() {
		return {
			executores: [],
		}
	},
	methods: {
		configurarExecutoresParaOtimizacao() {
			this.executores = []

			this.regrasDeOtimizacao.rendimentoOperacional.forEach((rendimentoOperacional) => {
				this.executores.push({
					executorId: rendimentoOperacional.coletor,
					parcelasPorDia: rendimentoOperacional.parcelasPorDia,
					quantidadeDeParcelasJaAlocadas: 0,
					datasEmServico: [],
					planejamentosDoExecutor: [],
				})
			})
		},
		otimizarOrdemDeServico() {
			this.configurarExecutoresParaOtimizacao()

			const ordemDeServicoPreCorte = '003'

			this.estratos
				// .filter(planejamento => planejamento.tipoDeOrdemDeServicoPlanejada !== ordemDeServicoPreCorte)
				.sort((planejamento1, planejamento2) => {
					const dataReferencia1 = new Date(planejamento1.dataReferencia)
					const diaReferencia1 = dataReferencia1.getDate()
					const mesReferencia1 = dataReferencia1.getMonth()
					let anoReferencia1 = 0

					const dataReferencia2 = new Date(planejamento2.dataReferencia)
					const diaReferencia2 = dataReferencia2.getDate()
					const mesReferencia2 = dataReferencia2.getMonth()
					let anoReferencia2 = 0

					if (mesReferencia1 < new Date(this.dataDeInicio).getMonth())
						anoReferencia1 = new Date(this.dataDeInicio).getFullYear() + 1
					else anoReferencia1 = new Date(this.dataDeInicio).getFullYear()

					if (mesReferencia2 < new Date(this.dataDeInicio).getMonth())
						anoReferencia2 = new Date(this.dataDeInicio).getFullYear() + 1
					else anoReferencia2 = new Date(this.dataDeInicio).getFullYear()

					return (
						new Date(anoReferencia1, mesReferencia1, diaReferencia1) -
						new Date(anoReferencia2, mesReferencia2, diaReferencia2)
					)
				})
				.forEach((planejamento) => {
					if (planejamento.tipoDeOrdemDeServicoPlanejada !== ordemDeServicoPreCorte) {
						const regraDeOtimizacao =
							this.recuperarRegraDeOtimizacaoConsiderandoOTipoDeOrdemDeServico(
								planejamento.tipoDeOrdemDeServicoPlanejada,
							)

						const dataReferencia = planejamento.dataReferencia
						const rangeDeDataDaOrdemDeServico =
							this.recuperarRangeParcialDeExecucaoDaOrdemDeServico(
								dataReferencia,
								regraDeOtimizacao,
							)

						const totalDeParcelas = planejamento.quantidadeDeParcelas
						const executor = this.recuperarExecutorDisponivelNoMesParaAlocarOrdemDeServico(
							rangeDeDataDaOrdemDeServico,
							totalDeParcelas,
						)
						const quantidadeDeDiasParaExecutarAOrdemDeServico = Math.ceil(
							totalDeParcelas / executor.parcelasPorDia,
						)

						if (rangeDeDataDaOrdemDeServico.inicioDaOS) {
							const referenciaDataInicial = new Date(rangeDeDataDaOrdemDeServico.inicioDaOS)
							rangeDeDataDaOrdemDeServico.finalDaOS = new Date(
								referenciaDataInicial.setDate(
									referenciaDataInicial.getDate() + quantidadeDeDiasParaExecutarAOrdemDeServico,
								),
							)
						} else {
							const referenciaDataFinal = new Date(rangeDeDataDaOrdemDeServico.finalDaOS)
							rangeDeDataDaOrdemDeServico.inicioDaOS = new Date(
								referenciaDataFinal.setDate(
									referenciaDataFinal.getDate() - quantidadeDeDiasParaExecutarAOrdemDeServico,
								),
							)
						}

						planejamento.inicioOs = rangeDeDataDaOrdemDeServico.inicioDaOS.getTime()
						planejamento.prazoOs = rangeDeDataDaOrdemDeServico.finalDaOS.getTime()
						planejamento.executorId = executor.executorId
						executor.quantidadeDeParcelasJaAlocadas += planejamento.quantidadeDeParcelas
						executor.datasEmServico.push(
							new Date(planejamento.inicioOs),
							new Date(planejamento.prazoOs),
						)

						executor.planejamentosDoExecutor.push({
							planejamentoId: planejamento.planejamentoId,
							inicioDaOS: planejamento.inicioOs,
							prazoOS: planejamento.prazoOs,
							quatidadeDeParcelas: planejamento.quantidadeDeParcelas,
						})
					} else {
						const existeRegraDePlanoDeColheita = this.regrasDeOtimizacao.planoDeColheita.length > 0

						if (existeRegraDePlanoDeColheita) {
							const regra = this.regrasDeOtimizacao.planoDeColheita
							const dataReferencia = planejamento.dataReferencia

							const executorComMenosParcelasAlocadas = this.executores.sort(
								(executor1, executor2) =>
									executor1.quantidadeDeParcelasJaAlocadas -
									executor2.quantidadeDeParcelasJaAlocadas,
							)[0]

							const quantidadeDeDiasParaExecutarAOrdemDeServico = Math.ceil(
								planejamento.quantidadeDeParcelas / executorComMenosParcelasAlocadas.parcelasPorDia,
							)

							if (regra.tipoDePrazo === 'PRAZOINICIAL') {
								planejamento.inicioOs = new Date(dataReferencia).getTime()
								planejamento.prazoOs = new Date(
									new Date(dataReferencia).setDate(
										new Date(dataReferencia).getDate() +
											quantidadeDeDiasParaExecutarAOrdemDeServico,
									),
								).getTime()
							} else {
								planejamento.inicioOs = new Date(
									new Date(dataReferencia).setDate(
										new Date(dataReferencia).getDate() -
											quantidadeDeDiasParaExecutarAOrdemDeServico,
									),
								).getTime()
								planejamento.prazoOs = new Date(dataReferencia).getTime()
							}

							planejamento.executorId = executorComMenosParcelasAlocadas.executorId
							executorComMenosParcelasAlocadas.quantidadeDeParcelasJaAlocadas +=
								planejamento.quantidadeDeParcelas
							executorComMenosParcelasAlocadas.planejamentosDoExecutor.push({
								planejamentoId: planejamento.planejamentoId,
								inicioDaOS: planejamento.inicioOs,
								prazoOS: planejamento.prazoOs,
								quatidadeDeParcelas: planejamento.quantidadeDeParcelas,
							})
						} else {
							const executorComMenosParcelasAlocadas = this.executores.sort(
								(executor1, executor2) =>
									executor1.quantidadeDeParcelasJaAlocadas -
									executor2.quantidadeDeParcelasJaAlocadas,
							)[0]

							planejamento.inicioOs = new Date().getTime()
							planejamento.prazoOS = new Date().getTime()

							planejamento.executorId = executorComMenosParcelasAlocadas.executorId
							executorComMenosParcelasAlocadas.quantidadeDeParcelasJaAlocadas +=
								planejamento.quantidadeDeParcelas
							executorComMenosParcelasAlocadas.planejamentosDoExecutor.push({
								planejamentoId: planejamento.planejamentoId,
								inicioDaOS: planejamento.inicioOs,
								prazoOS: planejamento.prazoOs,
								quatidadeDeParcelas: planejamento.quantidadeDeParcelas,
							})
						}
					}
				})
		},
		recuperarRegraDeOtimizacaoConsiderandoOTipoDeOrdemDeServico(tipoDeOrdemDeServico) {
			return this.regrasDeOtimizacao.tipoDeOrdemDeServico.find(
				(regra) => regra.tipoDeServico === tipoDeOrdemDeServico,
			)
		},
		recuperarRangeParcialDeExecucaoDaOrdemDeServico(dataDeReferencia, regraDeOtimizacao) {
			const dataCalculada =
				this.recuperarProximaDataDoCronogramaParaADataDeReferenciaPassadaPorParametro(
					dataDeReferencia,
					regraDeOtimizacao,
				)

			if (regraDeOtimizacao.tipoDePrazo === 'PRAZOINICIAL') {
				return {
					inicioDaOS: dataCalculada,
					finalDaOS: undefined,
				}
			} else if (regraDeOtimizacao.tipoDePrazo === 'PRAZOFINAL' && dataCalculada < new Date()) {
				return {
					inicioDaOS: new Date(),
					finalDaOS: undefined,
				}
			} else if (regraDeOtimizacao.tipoDePrazo === 'PRAZOFINAL') {
				return {
					inicioDaOS: undefined,
					finalDaOS: dataCalculada,
				}
			}

			console.error(`Tipo de prazo inválido: ${regraDeOtimizacao.tipoDePrazo}`)
		},
		recuperarProximaDataDoCronogramaParaADataDeReferenciaPassadaPorParametro(
			dataDeReferencia,
			regraDeOtimizacao,
		) {
			const dataReferencia = this.descontarMesesDaDataDeReferencia(
				dataDeReferencia,
				regraDeOtimizacao,
			)
			const dataDeInicio = new Date(this.dataDeInicio)

			dataReferencia.setFullYear(dataDeInicio.getFullYear())
			if (dataDeInicio > dataReferencia)
				dataReferencia.setFullYear(dataReferencia.getFullYear() + 1)

			return dataReferencia
		},
		descontarMesesDaDataDeReferencia(dataDeReferencia, regraDeOtimizacao) {
			if (regraDeOtimizacao.quantidadeDeMeses > 0) {
				return new Date(
					new Date(dataDeReferencia).setMonth(
						new Date(dataDeReferencia).getMonth() + regraDeOtimizacao.quantidadeDeMeses,
					),
				)
			} else if (regraDeOtimizacao.quantidadeDeMeses < 0) {
				return new Date(
					new Date(dataDeReferencia).setMonth(
						new Date(dataDeReferencia).getMonth() - Math.abs(regraDeOtimizacao.quantidadeDeMeses),
					),
				)
			} else {
				return new Date(dataDeReferencia)
			}
		},
		recuperarExecutorDisponivelNoMesParaAlocarOrdemDeServico(
			rangeDeDataDaOrdemDeServico,
			totalDeParcelas,
		) {
			const executoresDisponiveis =
				this.recuperarExecutoresDisponiveisNaDataExataParaAOrdemDeServico(
					rangeDeDataDaOrdemDeServico,
					totalDeParcelas,
				)

			if (executoresDisponiveis.length == 1) {
				return executoresDisponiveis[0]
			} else if (executoresDisponiveis.length > 1) {
				return this.retornarExecutorComMenosParcelasJaAlocadasEntreOsDisponiveis(
					executoresDisponiveis,
				)
			}

			return this.recuperarExecutorMaisProximoPossivelDaDataParaAOrdemDeServico(
				rangeDeDataDaOrdemDeServico,
				totalDeParcelas,
			)
		},
		recuperarExecutoresDisponiveisNaDataExataParaAOrdemDeServico(
			rangeDeDataDaOrdemDeServico,
			totalDeParcelas,
		) {
			const executoresDisponiveis = []
			this.executores.forEach((executor) => {
				const quantidadeDeDiasParaExecutarAOrdemDeServico = Math.ceil(
					totalDeParcelas / executor.parcelasPorDia,
				)

				const diasEmMilisegundos = 86400000
				let timestampInicio = 0
				let timestampFinal = 0

				if (rangeDeDataDaOrdemDeServico.inicioDaOS) {
					timestampInicio = rangeDeDataDaOrdemDeServico.inicioDaOS.getTime()
					timestampFinal =
						timestampInicio + diasEmMilisegundos * quantidadeDeDiasParaExecutarAOrdemDeServico
				} else if (rangeDeDataDaOrdemDeServico.finalDaOS) {
					timestampFinal = rangeDeDataDaOrdemDeServico.finalDaOS.getTime()
					timestampInicio =
						timestampFinal - diasEmMilisegundos * quantidadeDeDiasParaExecutarAOrdemDeServico
				}

				const timestampsOcupados = executor.datasEmServico.map((data) => data.getTime())
				const executorOcupado = timestampsOcupados.some(
					(timestampOcupado) =>
						timestampOcupado >= timestampInicio && timestampOcupado <= timestampFinal,
				)

				if (!executorOcupado) executoresDisponiveis.push(executor)
			})

			return executoresDisponiveis
		},
		retornarExecutorComMenosParcelasJaAlocadasEntreOsDisponiveis(executores) {
			return executores.sort(
				(executor1, executor2) =>
					executor1.quantidadeDeParcelasJaAlocadas - executor2.quantidadeDeParcelasJaAlocadas,
			)[0]
		},
		recuperarExecutorMaisProximoPossivelDaDataParaAOrdemDeServico(
			rangeDeDataDaOrdemDeServico,
			totalDeParcelas,
		) {
			let executorMaisProximoDaData = undefined
			this.executores.forEach((executor) => {
				const quantidadeDeDiasParaExecutarAOrdemDeServico = Math.ceil(
					totalDeParcelas / executor.parcelasPorDia,
				)
				const umDiaEmMilisegundos = 86400000
				let timestampInicio = 0
				let timestampFinal = 0

				// Range ideal de data de inicio e final da OS
				if (rangeDeDataDaOrdemDeServico.inicioDaOS) {
					timestampInicio = rangeDeDataDaOrdemDeServico.inicioDaOS.getTime()
					timestampFinal =
						timestampInicio + umDiaEmMilisegundos * quantidadeDeDiasParaExecutarAOrdemDeServico
				} else if (rangeDeDataDaOrdemDeServico.finalDaOS) {
					timestampFinal = rangeDeDataDaOrdemDeServico.finalDaOS.getTime()
					timestampInicio =
						timestampFinal - umDiaEmMilisegundos * quantidadeDeDiasParaExecutarAOrdemDeServico
				}

				let encontrouDataDisponivel = false
				const timestampOcupados = []

				// Preenche os timestamps que o executor está ocupado
				executor.planejamentosDoExecutor.forEach((planejamentoDoExecutor) => {
					timestampOcupados.push(planejamentoDoExecutor.inicioDaOS)
					timestampOcupados.push(planejamentoDoExecutor.finalDaOS)
				})

				// Encontra qual data o executor estara disponivel
				while (!encontrouDataDisponivel) {
					const executorOcupado = timestampOcupados.some(
						(timestampOcupado) =>
							timestampOcupado >= timestampInicio && timestampOcupado <= timestampFinal,
					)

					// Caso o executor esteja ocupado incrementa um dia da ordem de servico
					if (executorOcupado) {
						timestampInicio += umDiaEmMilisegundos
						timestampFinal += umDiaEmMilisegundos
					} else {
						// Caso o executor nao esteja ocupado, valida se o executor é o que está mais proximo a estar disponivel da data de inicio da OS
						if (executorMaisProximoDaData) {
							if (timestampInicio < executorMaisProximoDaData.timestampInicio) {
								executorMaisProximoDaData = {
									executorId: executor.executorId,
									timestampInicio,
									timestampFinal,
								}
							}
						} else {
							executorMaisProximoDaData = {
								executorId: executor.executorId,
								timestampInicio,
								timestampFinal,
							}
						}
						encontrouDataDisponivel = true
					}
				}
			})

			rangeDeDataDaOrdemDeServico.inicioDaOS = new Date(executorMaisProximoDaData.timestampInicio)
			rangeDeDataDaOrdemDeServico.finalDaOS = new Date(executorMaisProximoDaData.timestampFinal)

			return this.executores.find(
				(executor) => executor.executorId === executorMaisProximoDaData.executorId,
			)
		},
	},
	created() {
		if (this.possuiInformacoesDeRendimentoOperacional) this.configurarExecutoresParaOtimizacao()
	},
}
